"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = void 0;
var tslib_1 = require("tslib");
var get_cover_image_1 = require("../get-cover-image");
var mapUrls = function (category) {
    if (!category.url) {
        return {};
    }
    var path = category.url.path;
    //there was a bug in previous api, where category URL did not have a blog page path added to the path, and for backwards compatibility it must stay this way
    var trimmedPath = /(categories\/.+)/.exec(path)[1];
    return { categoryPageUrl: "/" + trimmedPath, fullCategoryPageUrl: "" + path };
};
var map = function (category) {
    var baseCategory = (0, tslib_1.__assign)({ _id: category.internalId, label: category.label, postCount: category.postCount, language: category.language, translationId: category.translationId, description: category.description }, (0, get_cover_image_1.getCoverImage)(category));
    var urls = mapUrls(category);
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, baseCategory), urls);
};
exports.map = map;
//# sourceMappingURL=platformized-mapper.js.map